function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          © {new Date().getFullYear()} Redux Cart System | All Rights Reserved
        </p>
        <p>
          Developed by{" "}
          <a
            href="https://github.com/PAIshanMadusha"
            target="_blank"
            rel="noopener noreferrer"
          >
            PAIshanMadusha
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
